import { useDragLayer } from 'react-dnd';
import CustomDragLayerBody from './body';
import { FileContext } from '../../context/FileContext';
import { useContext } from 'react';
import styled from 'styled-components';
import useCurrentOffsetEffect from './useCustomDraglayer';
import { useEnvelope } from '../../hooks/useEnvelope';
const layerStyles = {
  position: 'absolute',
  pointerEvents: 'none',
  zIndex: 100,
  top: 0,
  left: 0,
};

const XAxisGridLines = styled.div`
  position: absolute;
  z-index: 1000;
  height: ${({ height, scale }) => `${height / scale}px`};
  color: red;
  background-color: ${({ showLine }) => (showLine ? '#0073ea' : 'transparent')};
  width: 1px;
  top: ${({ top }) => `${top}px`};
  left: ${({ positionX, scale }) => `${positionX + 16 / scale}px`};
`;

const YAxisGridLines = styled.div`
  position: absolute;
  z-index: 1000;
  height: 1px;
  color: red;
  background-color: ${({ showLine }) => (showLine ? '#0073ea' : 'transparent')};
  width: ${({ width, scale }) => `${width / scale}px`};
  margin-left: ${({ scale }) => `${16 / scale}px`};
  left: 0;
  top: ${({ positionY }) => `${positionY}px`};
`;

function getItemStyles({
  initialOffset,
  currentOffset,
  documentRef,
  pdfDimensions,
  displacement,
}) {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    };
  }

  const rect = documentRef.current.getBoundingClientRect();
  //NOTE: here rect top is header and control toolbar section and 16 is the initial gap after controltoolbar to start of pdf
  const x = currentOffset?.x - rect.left;
  const displacementAtTop = displacement * pdfDimensions.scale;
  const y =
    currentOffset.y -
    rect.top -
    16 -
    displacementAtTop +
    documentRef.current?.scrollTop;
  const scaledX = x / pdfDimensions.scale;
  const scaledY = y / pdfDimensions.scale;

  return {
    left: scaledX,
    top: scaledY,
    position: 'absolute',
  };
}

export const CustomDragLayer = ({ itemId }) => {
  const {
    documentRef,
    pdfDimensions,
    addedFormFields,
    pdfIndividualPageDetails,
  } = useContext(FileContext);
  const { fileLinkTop } = useEnvelope();
  const { item, itemType, isDragging, initialOffset, currentOffset } =
    useDragLayer((monitor) => ({
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      initialOffset: monitor.getInitialSourceClientOffset(),
      currentOffset: monitor.getSourceClientOffset(),
      isDragging: monitor.isDragging(),
    }));

  const displacement = !!fileLinkTop ? 85 : 0;
  const closestCoordinatesData = useCurrentOffsetEffect(
    () => currentOffset,
    documentRef,
    pdfDimensions,
    addedFormFields,
    item,
    displacement,
    pdfIndividualPageDetails,
  );

  if (!isDragging || itemType !== 'Chips') {
    return null;
  }

  let adjustedCurrentOffset = currentOffset;

  if (
    closestCoordinatesData?.showX &&
    closestCoordinatesData?.closestX &&
    closestCoordinatesData?.showY &&
    closestCoordinatesData?.closestY
  ) {
    adjustedCurrentOffset = currentOffset;
    adjustedCurrentOffset = {
      ...adjustedCurrentOffset,
      ...(closestCoordinatesData?.reverseScaledClosestX
        ? {
            x: closestCoordinatesData?.reverseScaledClosestX + 16,
          }
        : {}),
      y: closestCoordinatesData?.reverseScaledClosestY,
    };
  } else {
    if (closestCoordinatesData?.showX && closestCoordinatesData?.closestX) {
      adjustedCurrentOffset = currentOffset;
      adjustedCurrentOffset = {
        ...adjustedCurrentOffset,
        ...(closestCoordinatesData?.reverseScaledClosestX
          ? {
              x: closestCoordinatesData?.reverseScaledClosestX + 16,
            }
          : {}),
      };
    }

    if (closestCoordinatesData?.showY && closestCoordinatesData?.closestY) {
      adjustedCurrentOffset = currentOffset;
      adjustedCurrentOffset = {
        ...adjustedCurrentOffset,
        y: closestCoordinatesData?.reverseScaledClosestY,
      };
    }
  }

  return (
    <>
      <XAxisGridLines
        positionX={closestCoordinatesData?.closestX}
        pageIndex={closestCoordinatesData?.pageIndex}
        height={
          (pdfIndividualPageDetails?.[closestCoordinatesData?.pageIndex]
            ?.height || 0) * pdfDimensions.scale
        }
        top={closestCoordinatesData?.activePageTop}
        scale={pdfDimensions.scale}
        showLine={closestCoordinatesData?.showX}
      ></XAxisGridLines>
      <YAxisGridLines
        positionY={closestCoordinatesData?.closestY}
        width={pdfDimensions.width}
        scale={pdfDimensions.scale}
        showLine={closestCoordinatesData?.showY}
      ></YAxisGridLines>
      <div style={layerStyles}>
        <div
          style={getItemStyles({
            initialOffset,
            currentOffset: adjustedCurrentOffset,
            documentRef,
            pdfDimensions,
            displacement,
          })}
        >
          <CustomDragLayerBody
            item={item}
            itemData={item}
            xCoordinate={item?.placeholder?.x}
            yCoordinate={item?.placeholder?.y}
          />
        </div>
      </div>
    </>
  );
};
